<!-- 分区计量-用户管理-平行大用户 -->
<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="horizontal" :labelCol="{ span: 5 }" :wrapperCol="{ span: 16 }">
        <a-row :gutter="48">
          <!-- 第一排 -->
          <a-col :md="6" :sm="12">
            <a-form-item label="片区选择">
              <a-tree-select :tree-data="zoneTreeData" v-model="query.belongingAreaId" style="width: 100%"
                :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择片区" allow-clear
                :treeDefaultExpandedKeys="treeDefaultExpandedKeys" show-search
                treeNodeFilterProp="title"></a-tree-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="用户名称">
              <a-input v-model="query.userName" placeholder="请输入用户名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="仪表编码">
              <a-input v-model="query.waterMeterNumber" placeholder="请输入仪表编码" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="水表口径">
              <a-input v-model="query.caliber" placeholder="请输入水表口径" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="用户编码">
              <a-input v-model="query.userCode" placeholder="请输入用户编码" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="用户地址">
              <a-input v-model="query.userAddress" placeholder="请输入用户地址" allow-clear />
            </a-form-item>
          </a-col>
          <!-- 第二排-操作按钮 -->
          <a-col :md="24" :sm="24">
            <div style="margin-bottom: 20px; display: flex;">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 12px" @click="addOrUpdateHandle()">新增</a-button>
              <a-button type="primary" style="margin-left: 12px"
                @click="downloadTemplate({ excelForm: true })">下载模板</a-button>
              <a-upload name="file" :multiple="false" @change="changeFile" :file-list="fileList"
                :customRequest="customRequest">
                <a-button type="primary" style="margin-left: 12px" :loading="importLoading">批量导入</a-button>
              </a-upload>
              <a-button type="primary" style="margin-left: 12px" @click="exportHandles()">导出</a-button>
              <a-button type="danger" style="margin-left: 12px" @click="deleteSelectRow()">删除</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table rowKey="id" :bordered="true"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="list"
      :columns="columns" :loading="dataListLoading" :pagination="pagination" @change="pageChange" :scroll="{ x: 1500 }">
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)">编辑</a>
      </span>
    </a-table>
    <user-add-or-update ref="addOrUpdate" @refreshDataList="queryList" />
  </a-card>
</template>

<script>
import axios from 'axios'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import mixinViewModule from '@/mixin/common' //选项式混合导入
import UserAddOrUpdate from './module/UserAddOrUpdate'

const columns = [ //表头参数
  {
    title: '所属片区',
    dataIndex: 'belongingArea',
    width: 150,
    ellipsis: true
  },
  {
    title: '用户编码',
    dataIndex: 'userCode',
    width: 150,
    ellipsis: true
  },
  {
    title: '平行大用户名称',
    dataIndex: 'userName',
    width: 150,
    ellipsis: true
  },
  {
    title: '仪表编码',
    dataIndex: 'waterMeterNumber',
    width: 150,
    ellipsis: true
  },
  {
    title: '用户地址',
    dataIndex: 'userAddress',
    width: 200,
    ellipsis: true
  },
  {
    title: '水表口径',
    dataIndex: 'caliber',
    width: 100,
    ellipsis: true
  },
  {
    title: '厂家',
    dataIndex: 'manufacturer',
    width: 150,
    ellipsis: true
  },
  {
    title: '安装日期',
    dataIndex: 'installDate',
    width: 180,
    ellipsis: true
  },
  {
    title: '经度',
    dataIndex: 'longitude',
    width: 120,
    ellipsis: true
  },
  {
    title: '纬度',
    dataIndex: 'latitude',
    width: 120,
    ellipsis: true
  },
  {
    title: '高程',
    dataIndex: 'elevation',
    width: 100,
    ellipsis: true
  },
  {
    title: '创建日期',
    dataIndex: 'createTime',
    width: 180,
    ellipsis: true
  },
  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',
    fixed: 'right',
    width: 100,
    scopedSlots: { customRender: 'action' },
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'ParallelLargeUser',
  components: {
    UserAddOrUpdate
  },
  data () {
    return {
      //needQuery: false, // 是否在created就执行查询操作
      currentId: '',
      queryUrl: '/zone-metering/parallel/user/page/select', //查询url
      deleteUrl: '/zone-metering/parallel/user/delete/list', //删除url
      //导出模板
      downloadTemplateUrl: 'zone-metering/parallel/user/list/export',
      downloadTemplateName: '平行大用户导入模板.xlsx',
      //导出数据
      exportDataUrl: 'zone-metering/parallel/user/list/data/export', //导出url
      exportFileName: '平行大用户数据.xlsx', //导出名称
      query: { //查询对象

      },
      pushTime: [],
      columns,
      queryZoneDateUrl: 'zone-metering/parallel/user/list/belongingArea',
      zoneTreeData: [], // 片区选项
      treeDefaultExpandedKeys: [], // 片区选项展开
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' })
    }
  },
  created () {
    this.getZoneData()
  },
  methods: {
    // 重置
    resetList () {
      this.pagination.current = 1
      this.query = {}
      this.selectedRows = []
      this.queryList()
    },
    // 获取采集时间
    pushOnChange () {
      if (this.pushTime && this.pushTime.length === 2) {
        this.query.currentIssueTimeBegin = this.pushTime[0].format('YYYY-MM-DD');
        this.query.currentIssueTimeEnd = this.pushTime[1].format('YYYY-MM-DD');
      }
    },
    exportHandles () {
      const params = { ...this.query }
      if (this.selectedRows && this.selectedRows.length > 0) {
        params.ids = this.selectedRows.join(',')
      }
      axios.get(`${process.env.VUE_APP_API_BASE_URL}${this.exportDataUrl}`, {
        params: params,
        responseType: 'blob',
        headers: {
          'Authorization': storage.get(ACCESS_TOKEN),
          'Accept': 'application/vnd.ms-excel'
        }
      })
        .then(response => {
          console.log('导出响应:', response);
          const blob = response.data;
          // 下载逻辑
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = this.exportFileName;
          link.click();
          window.URL.revokeObjectURL(url);

          this.$message.success('导出成功');
        })
        .catch(error => {
          console.log('导出失败:', error);
          this.$message.error('下载失败');
        })
        .finally(() => {
          this.resetList();
          this.importLoading = false
        })
    },
    getZoneData () {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
      }).catch(err => {
        console.log(err);
      })
    },
    addOrUpdateHandle (id) {
      this.$refs.addOrUpdate.init(id)
    },
    customRequest (info) {
      this.importLoading = true
      const formData = new FormData()
      formData.append('multipartFile', info.file)
      axios.post(`${process.env.VUE_APP_API_BASE_URL}zone-metering/parallel/user/list/import/export`, formData, {
        headers: {
          'Authorization': storage.get(ACCESS_TOKEN),
          'Accept': 'application/vnd.ms-excel'
        },
        responseType: 'blob'
      })
        .then(response => {
          const blob = response.data;
          console.log('获取到blob:', blob);
          if (blob.size == 0) {
            this.$message.success('导入成功');
          } else {
            // 下载逻辑
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `用户信息表_${new Date().getTime()}.xlsx`;
            link.click();
            window.URL.revokeObjectURL(url);

            this.$message.warning('导入成功,但有错误数据,请查看');
          }
        })
        .catch(error => {
          console.log('导入失败:', error);
          this.$message.error('下载失败');
        })
        .finally(() => {
          this.queryList();
          this.importLoading = false
        })
    },
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}
</style>
